export default __webpack_public_path__ + "static/media/Warglory Girdle.48959b31.jpg";